module.exports = __webpack_public_path__ + "img/3.41bb4f72.png";